import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  content: {
    margin: '0 auto',
    maxWidth: '1280px',
    width: '100%',
  },
  container: {
    paddingTop: theme.spacing(7),
    paddingBottom: theme.spacing(7),
  },
  item: {
    marginBottom: theme.spacing(2),
  },
  inputWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    flexShrink: 0,
    flexWrap: 'wrap',
    gap: theme.spacing(3),
  },
  cardItem: {
    flexDirection: 'column',
  },
  downloadIcon: {
    verticalAlign: 'middle',
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  downloadLink: {
    alignContent: 'center',
    cursor: 'pointer',
    textDecoration: 'none',
    color: theme.palette.secondary.main,
  },
  spinnerContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
